import React from 'react';
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import Helpdesk from "../../components/HelpDesk/HelpDesk";
import Footer from "../../components/Footer";

const HelpdeskPage = () => {

	return (
		<div>
			<Helmet>
				<title>Help Desk</title>
			</Helmet>
			<Header />
			<Helpdesk />
			<Footer />
		</div>
	);
};

export default HelpdeskPage;